import React from "react";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import Image from "next/image";
import Maaran from "@/assets/images/maaran_color_logo.svg";

import MaaranLogo from "@/assets/images/maaran_main_logo_black.svg";
import MaaranLogoColor from "@/assets/images/main_logo_white.svg";



import useDarkMode from "@/hooks/useDarkMode";

export default function HeaderBox() {


  const { open } = useSidebar();

  const {isDarkMode} = useDarkMode();

  const Logo = isDarkMode ? MaaranLogoColor : MaaranLogo;


  return (
    <div className={`flex items-center justify-between ${open ? 'flex-row' : 'flex-col gap-6'} `}>
      {open ?
      <div className="flex gap-3 items-center">
      <Image src={Logo} height={20} width={150} />
      </div>
      : <div className=" w-[4rem]">
        <img src={Maaran.src} alt="Maaran Logo"  className="h-full w-full object-contain" />
      </div>
      }

      <SidebarTrigger  />
    </div>
  );
}
